import { render } from "./OrientatorAnimation.vue?vue&type=template&id=a16056fe"
import script from "./OrientatorAnimation.vue?vue&type=script&lang=js"
export * from "./OrientatorAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__